import type { POStatus } from '@/hooks/usePurchaseOrders';
import { SOFT_BADGE_CLASSES, type SoftColor } from '@mustauto/ui/web';

const statusConfig: Record<POStatus, { color: SoftColor; label: string; muted?: boolean }> = {
  draft: { color: 'slate', label: 'Rascunho' },
  pending: { color: 'amber', label: 'Ag. Aprovação' },
  approved: { color: 'blue', label: 'Aprovada' },
  ordered: { color: 'indigo', label: 'Pedida' },
  partial: { color: 'orange', label: 'Parcial' },
  received: { color: 'emerald', label: 'Recebida' },
  cancelled: { color: 'slate', label: 'Cancelada', muted: true },
};

export function POStatusBadge({ status }: { status: POStatus }) {
  const config = statusConfig[status] ?? statusConfig.draft;
  const className = config.muted
    ? 'bg-slate-50 text-slate-400 dark:bg-slate-900/40 dark:text-slate-500'
    : SOFT_BADGE_CLASSES[config.color];
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-medium ${className}`}>
      {config.label}
    </span>
  );
}

export function GiroBadge({ label }: { label: 'alto' | 'medio' | 'baixo' }) {
  const colors: Record<string, SoftColor> = {
    alto: 'emerald',
    medio: 'amber',
    baixo: 'slate',
  };
  const labels: Record<string, string> = {
    alto: 'Alto',
    medio: 'Médio',
    baixo: 'Baixo',
  };
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${SOFT_BADGE_CLASSES[colors[label]]}`}
    >
      {labels[label]}
    </span>
  );
}

export type POAlert = 'overdue' | 'stale' | 'approaching' | null;

const alertConfig: Record<Exclude<POAlert, null>, { color: SoftColor; label: string }> = {
  overdue: { color: 'red', label: 'Atrasada' },
  stale: { color: 'amber', label: 'Sem atualiz.' },
  approaching: { color: 'yellow', label: 'Próx. entrega' },
};

export function POAlertBadge({ alert }: { alert: Exclude<POAlert, null> }) {
  const config = alertConfig[alert];
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-medium ${SOFT_BADGE_CLASSES[config.color]}`}
    >
      {config.label}
    </span>
  );
}

export function StockStatusBadge({ quantity, minQuantity }: { quantity: number; minQuantity: number }) {
  if (quantity === 0) {
    return (
      <span
        className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${SOFT_BADGE_CLASSES.red}`}
      >
        Zerado
      </span>
    );
  }
  if (quantity <= minQuantity) {
    return (
      <span
        className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ${SOFT_BADGE_CLASSES.amber}`}
      >
        Baixo
      </span>
    );
  }
  return null;
}
